module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sweet-modal-tab', {
      active: _vm.active
    }]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d25ddb84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/sweet-modal-vue/src/components/SweetModalTab.vue
// module id = 1861
// module chunks = 1